import CartItem from './cart-item'
import Queue from './queue'

const timeout = 1000;

export default class Cart {
  constructor({ catalog, id, items, service, subtotal, shop, total, vat, tableNumber = null }) {
    this.shop = shop;
    this.catalog = catalog;
    this.id = id;
    this.subtotal = subtotal;
    this.computedTotal = total;
    this.vat = vat;
    this.service = service;

    this.tableNumber = tableNumber;
    this.api = null;

    this.items = items;

    this.queue = new Queue();
    this.debounce = null;
  }

  get total() { 
    let ret = 0;

    this.items.forEach((i) => {
      ret += i.total.price.value;
    });

    return { value: ret, promo: null};
  }

  add(item) {
    return new Promise((resolve, reject) => {
      clearTimeout(this.debounce);
      let ret = null;
      
      const i = this.items.find(i => {
        if(i.product.id === item.product.id) {
          return i.options.filter(o => {
            return item.options.find(io => JSON.stringify(o.selection) === JSON.stringify(io.selection))
          }).length === i.options.length;
        }
      });


      if(item.isNew && i === undefined) {
        this.items.push(item);        
        this.queue.add({
          args: {
            cartId: this.id,
            itemId: item.id,
          },
          item: item.toCheckout(),
          func: this.api.post.bind(this.api)
        });
      } else {
        i.quantity += item.quantity;
        this.update(i);
      }

      this.debounce = setTimeout(() => {
        this.queue.trigger().then((data) => {
          ret = new Cart(Cart.fromJSON(data));
          ret.api = this.api;
          resolve(ret);
        }).catch(reject);
      }, timeout);
    });
  }

  update(item) {
    return new Promise((resolve, reject) => {
      clearTimeout(this.debounce);
      let ret = null;
      
      if(item.quantity > 0) {
        this.queue.add({
          args: {
            cartId: this.id,
            itemId: item.id,
          },
          item: {
            quantity: item.quantity
          },
          func: this.api.put.bind(this.api)
        });
      } else {
        const temp = this.items.find(i => i.id === item.id);
        const index = this.items.indexOf(temp);
        this.items.splice(index, 1);

        this.queue.add({
          args: {
            cartId: this.id,
            itemId: item.id,
          },
          item: null,
          func: this.api.delete.bind(this.api)
        });
      }
      this.debounce = setTimeout(() => {
        this.queue.trigger().then((data) => {
          ret = new Cart(Cart.fromJSON(data));
          ret.api = this.api;
          resolve(ret);
        }).catch(reject);
      }, timeout);
    });
  }

  static fromJSON(json) { 
    const items = json.items.map(i => {
      return new CartItem(CartItem.fromJSON(i));
    });

    return {
      catalog: json.catalog_id,
      embed: json.embed_id,
      id: json.id,
      items: items,
      service: json.service,
      shop: json.shop_id,
      status: json.status,
      subtotal: json.computed_subtotal_price,
      total: json.computed_total_price,
      vat: json.computed_vat_price
    };
  }
}